import { ErrorHandler, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './error.interceptor';
import { GlobalErrorHandler } from './global-error.handler';

export function provideError(): EnvironmentProviders {
    return makeEnvironmentProviders([
        // registriert den funktionalen Error-Interceptor – identischer Stil zu provideAuth()
        provideHttpClient(withInterceptors([errorInterceptor])),

        // globaler Angular-ErrorHandler (nicht-HTTP-Fehler)
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
    ]);
}
